import { z } from "zod";
import { dateOnlyStringSchema } from "./date";
import { membershipPaymentDecisionFields, refineMembershipPaymentDecision, } from "./payments";
const defaultValidationTranslate = (key, params) => {
    const fallbackMessages = {
        required: "This field is required",
        positiveNumber: "Must be a positive number",
        nonNegativeNumber: "Must be zero or greater",
        minLength: `Minimum length is ${params?.min ?? 1} characters`,
    };
    return fallbackMessages[key] ?? key;
};
export const assignMembershipSchema = z
    .object({
    userId: z.string().min(1, "Member ID is required"),
    membershipPlanId: z.number(),
    startDate: dateOnlyStringSchema,
    clubId: z.number().min(1, "Club ID is required"),
    autoMarkPaid: z.boolean().default(true),
    ...membershipPaymentDecisionFields,
})
    .superRefine(refineMembershipPaymentDecision);
export const renewMembershipSchema = z
    .object({
    membershipPlanId: z.number().optional(),
    startFromDate: dateOnlyStringSchema.optional(),
    forceOverlap: z.boolean().optional(),
    autoMarkPaid: z.boolean().optional(),
    ...membershipPaymentDecisionFields,
})
    .superRefine(refineMembershipPaymentDecision);
export const updateMembershipSchema = z.object({
    clubId: z.number().min(1, "Club ID is required"),
    membershipPlanId: z.number(),
    startDate: dateOnlyStringSchema,
    subscriptionId: z.number().min(1, "Subscription ID is required"),
});
export const correctMembershipValiditySchema = z.object({
    clubId: z.number().min(1, "Club ID is required"),
    startDate: dateOnlyStringSchema,
    reason: z.string().trim().min(1, "Correction reason is required").max(500),
    expectedConcurrencyToken: z.string().uuid("Concurrency token is required"),
});
export function createLocalizedMembershipPlanSchema(t = defaultValidationTranslate) {
    return z.object({
        name: z.string().min(1, t("required")),
        price: z.number().nonnegative(t("nonNegativeNumber")),
        durationValue: z.number().positive(t("positiveNumber")),
        durationUnit: z.enum(["Day", "Week", "Month", "Year"]),
        planType: z.enum(["Standard", "Premium", "Family", "Student"], {
            error: t("required"),
        }),
        visibilityPolicy: z.enum(["Public", "Internal"], {
            error: t("required"),
        }),
    });
}
export const createMembershipPlanSchema = createLocalizedMembershipPlanSchema();
